import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import MakeBanner from "./MakeBanner";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import {useTranslation} from "react-i18next";
import {AddBox, ChevronRightRounded} from "@mui/icons-material";
import {Pencil} from "lucide-react";

const MakeBannerButton = ({ id: propId, reload, position, model, page }) => {
    const [open, setOpen] = useState(false);
    const [id, setId] = useState(propId);
    const [run, setRun] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setId(propId);
    }, [propId]);

    const toggleOpen = async () => {
        setOpen((prevOpen) => !prevOpen);
        setRun(!open);
    };

    const handleReload = async () => {
        await toggleOpen();
        reload();
    };

    return (
        <>
            {!!id ? (
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={toggleOpen}
                    startIcon={<Pencil className="lucide-icon-secondary btn" />}
                    size="small"
                    style={{ marginBottom: 5, marginRight: 5 }}
                >
                    {t('edit')}
                </Button>
            ) : (
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={toggleOpen}
                    startIcon={<AddBox />}
                >
                    {t('addBanner')}
                </Button>
            )}

            <Dialog
                open={open}
                onClose={toggleOpen}
                aria-labelledby="form-dialog-title"
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle id="form-dialog-title">
                    {!!id ? t('editBanner') : t('addBanner')}
                    <IconButton
                        onClick={toggleOpen}
                        style={{ position: "absolute", right: 15, top: 15 }}
                        size="small"
                    >
                        <CloseRoundedIcon fontSize="small" />
                    </IconButton>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    {run && (
                        <MakeBanner
                            position={position}
                            model={model}
                            id={id}
                            reload={handleReload}
                            page={page}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default MakeBannerButton;
